import React from 'react'
import { cx } from '@emotion/css'

export interface Props {
    className?: string
    duration?: string
    source?: string
}

export const VideoMetadata: React.FC<Props> = ({ className, duration, source }) => {
    if (!duration && !source) {
        return null
    }

    return (
        <p className={cx(className, 'video-metadata')}>
            {duration && <time>{duration}</time>}
            {duration && source && ' | '}
            {source && <span>{source}</span>}
        </p>
    )
}
VideoMetadata.displayName = 'VideoMetadata'
